// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"8d5750fb","893":"e4c48e22","976":"fdbb261d"}[chunkId] + ".chunk.js";
};